module.exports = __webpack_public_path__ + "img/five.92098fa5.png";